import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import TextOptions from "%/dynamic-components/render-engine/bundles/text-options";
import SpacingOptions from "%/dynamic-components/render-engine/bundles/spacing-options";
import {
  TextElementMixin,
} from "%/dynamic-components/render-engine/components/production/elements/text-element/text-element-mixin";
import BasicTextOptions from "%/dynamic-components/render-engine/bundles/basic-text-options";
import LayoutWidthHeightOptions from "%/dynamic-components/render-engine/bundles/layout-width-height-options";
import BrandedTextStyleOptions from "%/dynamic-components/render-engine/bundles/branded-text-style-options";
import BackgroundOptions from "%/dynamic-components/render-engine/bundles/background-options";
import EffectsOptions from "%/dynamic-components/render-engine/bundles/effects-options";
import BorderOptions from "%/dynamic-components/render-engine/bundles/border-options";
import ClickAction from "%/dynamic-components/render-engine/options/click-actions/click-action";
import TypographyBranding from "%/dynamic-components/render-engine/classes/branding/typography-branding";

export const StaticBrandedTextElementMixin = {
  mixins: [DynamicElementMixin, TextElementMixin],
  brandingType: TypographyBranding,
  optionBundles: [
    new LayoutWidthHeightOptions({}, {
      "layout-height": true,
      "max-height": true,
      "min-height": true,
    }),
    new BrandedTextStyleOptions({
      "default.text-branding-style-option": "paragraph",
    }, {
      "text-option": true,
    }),
    BasicTextOptions,
    TextOptions,
    SpacingOptions,
    EffectsOptions,
    BorderOptions,
    new BackgroundOptions({}, {
      "background-image": true,
      "background-gradient": true,
    }),
  ],
  options: [
    ClickAction,
  ],
  computed: {
    isEditable() {
      return true;
    },
    value() {
      return "";
    },
    shouldShowText() {
      return true;
    },
  },
  methods: {
    setDefaultBrandingValue() {
      // override text element mixin method to avoid adding text branding store
    },
  },
};
